export default {
  props: ['field', 'number'],

  template: '#file_dropzone_template',

  methods: {
    initDropZone() {
      let self = this;
      let $el = $('#dz-row-' + this.field.id).find('.dz-container');
      let mediaDZ;

      let message = JST['templates/dropzone-generic']({
        title: this.field.name,
        hideUpperTitle: true,
        fileTypes: this.field.definition[0].file_types,
        maxFilesize: 5000,
        acceptedFiles: this.field.definition[0].file_types.trim(),
        dropFilesTitle: Kadenze.I18n.t('drop_file_editor.drop_file_title'),
        dragAndDrop: Kadenze.I18n.t('drop_file_editor.drag_and_drop'),
        browseFiles: Kadenze.I18n.t('drop_file_editor.browse_files'),
        dimentionLabel: Kadenze.I18n.t('drop_file_editor.dimensions_label'),
        maxFilesizeLabel: Kadenze.I18n.t('drop_file_editor.max_file_size'),
        fileTypesLabel: Kadenze.I18n.t('drop_file_editor.file_types'),
        optionalLable: Kadenze.I18n.t('drop_file_editor.optional')
      });

      let opts = {
        url: Kadenze.Routes.coursework_field_entries_path(),
        autoProcessQueue: true,
        previewsContainer: '#dz-row-' + this.field.id + ' .js-dz-mediaHolder',
        paramName: 'coursework_field_entry[file]',
        acceptedFiles: this.field.definition[0].file_types.trim(),
        maxFilesize: 5000,
        maxFiles: this.field.max_files_allowed,
        previewTemplate: Kadenze.I18n.tt(JST['templates/dropzone-coursework-preview']()),
        sortItems: '.js-dz-preview',
        sortHandle: '.js-dz-sortHandle',
        sortNumber: '.js-dz-orderNumber',
        chunking: true,
        forceChunking: true,
        chunkSize: 250 * 1000 * 1000, // bytes
        accept: function(file, done) {
          if (file.size === 0) {
            done('Please make sure file is not empty.');
          } else { done(); }
        },
      };

      self.orderUpdate = function() {
        $(opts.previewsContainer).find('.js-dz-preview ').each(function() {
          $(this).find('.js-dz-orderNumber').text($(this).index() + 1);
        });
      };

      let callbacks = {
        chunksUploaded: (file, doneFn) => doneFn(file),
        done: function(file) { this.trigger('complete', file) },
        addedfile: function(file) {
          //This is for setting a default thumbnail when a non-image file is added to the dz for the first time
          if (!file.type.match(/image.*/) && !file.thumb) {
            mediaDZ.emit('thumbnail', file, asset_path('file_upload/dropzone-thumb.png'));
          }
          if(mediaDZ.files.length > 0 ) {
            $('#dz-row-' + self.field.id + ' .js-dz-previewArea').show();
          } else {
            $('#dz-row-' + self.field.id + ' .js-dz-previewArea').hide();
          }

          //update ordering
          self.orderUpdate();
        },
        success: function(file, response) {
          if (response == '')
            file.id = JSON.parse(file.xhr.response).files[0].id;
          else
            file.id = response.files[0].id;

          self.$parent.addFieldEntryId(self.field.id, file.id);

          $(file.previewTemplate).attr('id', 'coursework_field_entry_' + file.id);
          $(file.previewTemplate).attr('value', file.id);
          self.$parent.uploading = false;
        },

        sending: function(file, response, formData) {
          formData.append('coursework_field_entry[coursework_field_id]', self.field.id);
          self.$parent.uploading = true;
        },

        error(file, errorMessage) {
          let message

          if (typeof errorMessage === 'string') {
            message = errorMessage
          } else if (errorMessage.errors) {
            message = errorMessage.errors[0] || I18n.t('error.error')
          } else {
            message = I18n.t('error.error')
          }

          new Kadenze.Notice.error({ message });
          mediaDZ.removeFile(file);
        },

        removedfile: function(file) {
          if (!isNaN(parseInt(file.id))) {
            self.$parent.removeFieldEntryId(self.field.id, file.id);
            if (mediaDZ.options.maxFiles < opts['maxFiles'])
              mediaDZ.options.maxFiles++;
          }
          if(mediaDZ.files.length > 0 ) {
            $('#dz-row-' + self.field.id + ' .js-dz-previewArea').show();
          } else {
            $('#dz-row-' + self.field.id + ' .js-dz-previewArea').hide();
          }
        },

        maxfilesexceeded: function(file) {

        },

        sortableUpdate: function(e, ui) {
          $.ajax({
            url: Kadenze.Routes.sort_coursework_field_entries_path(),
            type: 'POST',
            data: $(opts.previewsContainer).sortable('serialize'),

            beforeSend: function(xhr, settings) {
              Kadenze.UIUtil.showLoadingIndicator($el);
            },

            success: function(data, textStatus, xhr) {
              new Kadenze.Notice.success({message: 'Successfully reordered files.'});
            },

            error: function(xhr, textStatus, errorThrown) {
              new Kadenze.Notice.error({message: 'We were unable to reorder these files. Please try again.'});
            },

            complete: function(xhr, textStatus) {
              Kadenze.UIUtil.hideLoadingIndicator($el);
            }
          });
          self.orderUpdate();
        }
      };

      mediaDZ = new Kadenze.MediaDropZone($el, $(message), opts, callbacks, true);

      //https://github.com/enyo/dropzone/wiki/FAQ#how-to-show-files-already-stored-on-server
      _.each(this.field.coursework_field_entries, function (entry) {
        if (entry.id && entry.file.url) {
          let mockFile = { id: entry.id, name: entry.name, size: entry.size, path: entry.file.url, thumb: entry.file.thumb.url,
            status: Dropzone.SUCCESS, type: entry.type, accepted: true };
          mediaDZ.addMockFile(mockFile);
        }
      });

      this.$parent.dzInstances.push(mediaDZ);
    }
  },

  mounted() {
    this.initDropZone();
  }
};
